import React from 'react';
import { LuCheck, LuLoader } from 'react-icons/lu';

// Botón de guardado con progreso (27-oct-2026): mientras se cierra un trabajo muestra en qué va
// ("Subiendo fotos 3/8", "Guardando el trabajo…") con una barra que se llena, en vez de quedar
// apagado sin saber si está trabado. Lo usan los tres cierres: por N/S, registrar y ejecutar.
// progreso = { texto, pct }   color = color de la barra (el fondo es el mismo, más claro)
export default function BotonProgreso({ progreso, color = '#D13A28', className = 'h-12 rounded-xl', aviso = true }) {
    const pct = Math.max(6, Math.min(100, Math.round(progreso?.pct ?? 10)));
    return (
        <div className="w-full">
            <div role="status" aria-live="polite"
                className={`relative w-full overflow-hidden text-white ${className}`}
                style={{ background: `color-mix(in srgb, ${color} 45%, transparent)` }}>
                <div className="absolute inset-y-0 left-0 transition-[width] duration-500 ease-out" style={{ width: `${pct}%`, background: color }} />
                <div className="absolute inset-0 bg-[linear-gradient(110deg,transparent_30%,rgba(255,255,255,.18)_50%,transparent_70%)] bg-[length:200%_100%] animate-[brillo_1.4s_linear_infinite]" />
                <span className="relative h-full flex items-center justify-center gap-2 px-3 font-black text-label uppercase">
                    {pct >= 100 ? <LuCheck size={16} className="shrink-0" /> : <LuLoader size={16} className="shrink-0 animate-spin" />}
                    <span className="truncate">{progreso?.texto || 'Guardando…'}</span>
                </span>
            </div>
            {aviso && <p className="mt-2 text-center text-label text-muted">No cierres la app hasta que termine.</p>}
        </div>
    );
}
